import React from 'react'
import styled from 'styled-components'

import {information_data} from '../../data/aboutData'
import AboutInfoWithDate from '../../atoms/AboutInfoWithDate'

import {_makeCapitalize} from '../../utils/helpers'

export default ({type}) => {
  return (
    <Container type={type}>
      <MainTitle type={type}>{_makeCapitalize(type)}</MainTitle>
      {information_data[type].map((data, index) => <AboutInfoWithDate key={index} type={type} data={data}/>)}
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  height: auto;
  padding: 3rem 2rem;
  background-color: ${props => props.type === 'career' ? props.theme.beige : props.theme.green};
  @media(min-width: 1100px) {
    margin: 0 auto;
    width: ${props => props.type === 'career' ? '70%' : '100%'};
    padding: ${props => props.type === 'career' ? '3rem 2rem' : '3rem 16%'};
  }
  @media(min-width: 1300px) {
    position: relative;
    padding: 7rem 2rem 3rem;
    padding: ${props => props.type === 'career' ? '7rem 2rem 3rem' : '4rem 21%'};
    width: ${props => props.type === 'career' ? '60%' : '100%'};
    top: -3rem;
  }
`
const MainTitle = styled.h2`
  width: 100%;
  color: ${props => props.type === 'career' ? props.theme.green : props.theme.beige};
  font-family: ELEPHNT;
  border-left: 3px solid ${props => props.type === 'career' ? props.theme.green : props.theme.beige};
  padding: 0 1rem;
  margin-bottom: 2rem;
  letter-spacing: 0.2rem;
  @media(min-width: 900px) {
    font-size: 2rem;
    margin-left: 3rem;
  }
`